export default __webpack_public_path__ + "static/dhsp-5d65bb37b3b7d238b3a225d16876a8ad.png";